import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/ReportView.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue')
  },
  {
    path: '/lers',
    name: 'lers',
    component: () => import('../views/LersSyncView.vue')
  },
  {
    path: '/data',
    children: [
      {
        path: '',
        name: 'data',
        component: () => import('../views/DataView.vue'),
      },
      {
        path: ':id',
        name: 'object',
        component: () => import('../views/TargetDataView.vue'),
      }
    ]
  },
  {
    path: '/equipment/:id',
    name: 'equipment-details',
    component: () => import('../views/EquipmentDetailsView.vue'),
    props: true
  },
  {
    path: '/equipment',
    name: 'equipment-list',
    component: () => import('../views/EquipmentListView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

/**
 * Проверяет наличие JWT и что он ещё не истёк.
 * Возвращает true только если токен существует и payload.exp > now.
 */
function isTokenValid(token) {
  if (!token) return false
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp * 1000 > Date.now()
  } catch {
    return false
  }
}

// Route guard для защиты страниц авторизацией
router.beforeEach((to, _from, next) => {
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)

  let valid = false
  try {
    const raw = localStorage.getItem('user')
    if (raw) {
      const user = JSON.parse(raw)
      valid = isTokenValid(user?.access)
      // Если access истёк — чистим, чтобы не было мусора
      if (!valid) localStorage.removeItem('user')
    }
  } catch {
    localStorage.removeItem('user')
  }

  if (authRequired && !valid) {
    return next('/login')
  } else if (to.path === '/login' && valid) {
    return next('/')
  } else {
    next()
  }
});

export default router
